export enum TypeQuote {
    Leasing = 'Leasing',
    credit = 'Credit',
}

export enum TypeProduct {
    LeasingRenting = 'leasing-renting',
    Rent2buy = 'rent2buy',
    Traditional = 'traditional',
    Ballon = 'ballon',
}

export enum TypeQuoter {
    Quoter = 'cotizador',
    Credit = 'cotizador-credito'
}


export enum TypeQuoterCredit {
    traditional = 'TRADITIONAL',
    ballon = 'BALLON'
}

export enum TypeQuoterCreditConcepts {
    traditional = 'traditional',
    ballon = 'ballon'
}

export enum TypeQuoterFullName {
    traditional = 'Crédito Tradicional',
    ballon = 'Crédito Balloon'
}

export const CREDIT_CONCEPTS = [
    TypeQuoterCreditConcepts.traditional.toString(),
    TypeQuoterCreditConcepts.ballon.toString()
];

export const SUSTITUECAROPTS = [
    { text: 'Subcompacto', value: 4 },
    { text: 'SUV', value: 5 },
];


export const SUSTITUECAROPTSHASH: {[key: string]: string}  = SUSTITUECAROPTS.reduce((acc: {[key: string]: string} , curr) => {
    if (!acc[curr.value]) {
        acc[`${curr.value}`] = curr.text;
    }
    return acc;
}, {});

export const MONTHS = [ 'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
export const KEY_MONTHS = [
    {
        id: 0,
        name: 'Enero'
    },
    {
        id: 1,
        name: 'Febrero'
    },
    {
        id: 2,
        name: 'Marzo'
    },
    {
        id: 3,
        name: 'Abril'
    },
    {
        id: 4,
        name: 'Mayo'
    },
    {
        id: 5,
        name: 'Junio'
    },
    {
        id: 6,
        name: 'Julio'
    },
    {
        id: 7,
        name: 'Agosto'
    },
    {
        id: 8,
        name: 'Septiembre'
    },
    {
        id: 9,
        name: 'Octubre'
    },
    {
        id: 10,
        name: 'Noviembre'
    },
    {
        id: 11,
        name: 'Diciembre'
    }
];
export const BINARY = ['Si', 'No'];
export const BINARY_OBJ = [
    {
        label: 'Si',
        value: true
    },
    {
        label: 'No',
        value: false
    }
];

export const INSURANCE_PAYMENT_TYPE_OPTS: string[] = [
    'Anual de Contado',
   'Anual Financiado'
];

export enum InsuranceTypeIDsEnum {
    ANUAL_CONTADO_SIN_PAGO_ANUAL = 1,
    ANUAL_FINANCIADO_SIN_PAGO_ANUAL,
    ANUAL_CONTADO_CON_PAGO_ANUAL,
    ANUAL_FINANCIADO_CON_PAGO_ANUAL
}

enum InsuranceTypeEnum {
    ANUAL_CONTADO_SIN_PAGO_ANUAL = 'Multianual de contado', // Multianual de contado
    ANUAL_FINANCIADO_SIN_PAGO_ANUAL = 'Multianual Financiado', // Multianual Financiado
    ANUAL_CONTADO_CON_PAGO_ANUAL = 'Multianual de Contado.', // Anual de Contado
    ANUAL_FINANCIADO_CON_PAGO_ANUAL = 'Multianual Financiado.' // Anual Financiado
}

export const InsuranceIdToName = Object.freeze({
    [InsuranceTypeIDsEnum.ANUAL_CONTADO_SIN_PAGO_ANUAL]: InsuranceTypeEnum.ANUAL_CONTADO_SIN_PAGO_ANUAL.toString(),
    [InsuranceTypeIDsEnum.ANUAL_FINANCIADO_SIN_PAGO_ANUAL]: InsuranceTypeEnum.ANUAL_FINANCIADO_SIN_PAGO_ANUAL.toString(),
    [InsuranceTypeIDsEnum.ANUAL_CONTADO_CON_PAGO_ANUAL]: InsuranceTypeEnum.ANUAL_CONTADO_CON_PAGO_ANUAL.toString(),
    [InsuranceTypeIDsEnum.ANUAL_FINANCIADO_CON_PAGO_ANUAL]: InsuranceTypeEnum.ANUAL_FINANCIADO_CON_PAGO_ANUAL.toString()
});

export const INSURANCE_PAYMENT_TYPE_OPTS_MAP: {id: InsuranceTypeIDsEnum, name: string, active: boolean}[] = [
    {
        id: InsuranceTypeIDsEnum.ANUAL_CONTADO_SIN_PAGO_ANUAL,
        active: true,
        name: InsuranceIdToName[InsuranceTypeIDsEnum.ANUAL_CONTADO_SIN_PAGO_ANUAL]
    },
    {
        id: InsuranceTypeIDsEnum.ANUAL_FINANCIADO_SIN_PAGO_ANUAL,
        active: true,
        name: InsuranceIdToName[InsuranceTypeIDsEnum.ANUAL_FINANCIADO_SIN_PAGO_ANUAL]
    },
    /* TODO: FASE 2 */
    {
        id: InsuranceTypeIDsEnum.ANUAL_CONTADO_CON_PAGO_ANUAL,
        active: false,
        name: InsuranceIdToName[InsuranceTypeIDsEnum.ANUAL_CONTADO_CON_PAGO_ANUAL]
    },
    {
        id: InsuranceTypeIDsEnum.ANUAL_FINANCIADO_CON_PAGO_ANUAL,
        active: false,
        name: InsuranceIdToName[InsuranceTypeIDsEnum.ANUAL_FINANCIADO_CON_PAGO_ANUAL]
    },
    /* TODO: FASE 2 */
];


export const MAINTENANCE_RANGE = {
    MIN: 20, // 20K
    MAX: 120 // 120K
}

export const CATALOG_IDENTY = [
    {
        label: 'INE',
        entidad: 'INE',
        value: 'INE',
    },
    {
        label: 'Pasaporte',
        entidad: 'SRE',
        value: 'Pasaporte',
    },
    {
        label: 'Cédula profesional',
        entidad: 'SEP',
        value: 'Cédula profesional',
    },
    {
        label: 'FM2 (residente permanente)',
        entidad: 'INM',
        value: 'FM2 (residente permanente)',
    },
    {
        label: 'Otro',
        entidad: '',
        value: 'Otro',
    },

];

export enum PeriodType {
    Months12 = 'period12',
    Months24 = 'period24',
    Months36 = 'period36',
    Months48 = 'period48',
    Months60 = 'period60',
}

export enum PeriodTypeName {
    period12 = 'Plazo 12',
    period24 = 'Plazo 24',
    period36 = 'Plazo 36',
    period48 = 'Plazo 48',
    period60 = 'Plazo 60',
}

export enum TypePerson {
    PFA = 'PFA',
    PFAE = 'PFAE',
}

export enum ErrorBuro {
    NO_HISTORIAL = "-9"
}

export const DAVINCI_EXTRANJERO_ID = 99;
